import { render, staticRenderFns } from "./defTableSocketResult.vue?vue&type=template&id=205505cd&"
import script from "./defTableSocketResult.vue?vue&type=script&lang=js&"
export * from "./defTableSocketResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports